import StateProvider from './state';
import { BrowserRouter, Outlet, Route, Routes, useLocation } from "react-router";
import 'dayjs/locale/it';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import { Header } from './components/header';
import { TrackList } from './components/tour/tour_list';
import { Tour } from './components/tour/tour_details';
import { FullMappList, FullTrackList } from './components/tour/tour_full_list';
import { Checkout } from './components/checkout/checkout';
import { Preferites } from './components/preferites';
import { UserProfile } from './components/profile/userProfile';
import { CompletePayment, PaymentPage } from './components/tour/payment';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Account } from './components/account/account';
import ManagerRequests from './components/manager';
import "./App.css";
import "./map.css";

const GOOGLE_CLIENT_ID = "568657835429-11l7i8nnbhj4287ad2vh1slm72h3mihi.apps.googleusercontent.com"


if(window.location.href.indexOf("https://admin.outdoora.app/?test=1") === -1) {
  if(window.location.href.indexOf("https://admin.outdoora.app") !== -1 && window.location.href.indexOf("https://admin.outdoora.app/admin") === -1 && window.location.href.indexOf("/manager") === -1) {
    window.location.href = "https://admin.outdoora.app/admin/";
  }
}

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <StateProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>

            <Route path="manager/:token" element={<ManagerRequests />} />
            <Route path="manager" element={<ManagerRequests />} />

            <Route index element={<TrackList />} />
            
            <Route path="map/" element={<FullMappList />} />
            
            <Route path="list/" element={<FullTrackList />} />
            <Route path="list/tour/:id" element={<Tour />} />
            
            <Route path="tour/:id" element={<Tour />} />
            <Route path="tour/:id/payment" element={<PaymentPage />} />

            <Route path="account" element={<Account />} />

            <Route path="checkout" element={<Checkout />} />
            <Route path="checkout/tour/:id" element={<Tour />} />
            <Route path="checkout/payment" element={<PaymentPage />} />
            
            <Route path="profile" element={<UserProfile />} />
            <Route path="payment_landing" element={<CompletePayment />} />
            <Route path="saved" element={<Preferites />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </StateProvider>
    </GoogleOAuthProvider>
  );
}



const Layout = () => {

  const mobile = window.innerWidth <= 600
  const homepage = window.location.pathname === '/'
  const headerHeight = mobile && homepage ? 0 : 68;
  const {pathname} = useLocation()

  let hideHeaderSearchBar = false;
  if(pathname.startsWith('/map')) {
    hideHeaderSearchBar = true
  }
  let hide = false;
  if(pathname.startsWith("/manager")) {
    hide = true
  }
  if(hide) {
    return <Outlet />
  }
  return (
    <div>
      <Header hideSearchBar={hideHeaderSearchBar} />
      <div style={{ marginTop: headerHeight }}>
        <Outlet />
      </div>
    </div>
  )
}



export default App;
